import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'projectFilter'
})
export class ProjectFilterPipe implements PipeTransform {

  transform(projectList: any, term?: any): any {
    //return null;
    if (term === undefined || term === '') { return projectList; };
    return projectList.filter(function(item){
      if (item.description && item.description.toLowerCase().includes(term.toLowerCase())) {
        return item.description.toLowerCase().includes(term.toLowerCase());
      }
      if (item.name && item.name.toLowerCase().includes(term.toLowerCase())) {
        return item.name.toLowerCase().includes(term.toLowerCase());
      }
      if (item.code && item.code.toLowerCase().includes(term.toLowerCase())) {
        return item.code.toLowerCase().includes(term.toLowerCase());
      }
    });
  }

}
